/**
 * Estado de filtros da aba Passagens do Dashboard.
 */

export const EMPTY_PASSAGENS_FILTER_STATE = {
  origens: [],
  destinos: [],
  ids_origens: [],
  status: "",
  labels: {
    origens: {},
    destinos: {},
    channels: {},
  },
};

function toPositiveIntArray(raw) {
  const list = Array.isArray(raw) ? raw : raw != null && raw !== "" ? String(raw).split(",") : [];
  const out = [];
  const seen = new Set();
  for (const item of list) {
    const n = Number(String(item ?? "").trim());
    if (!Number.isFinite(n) || n <= 0 || seen.has(n)) continue;
    seen.add(n);
    out.push(n);
  }
  return out;
}

function toStringIdArray(raw) {
  const list = Array.isArray(raw) ? raw : raw != null && raw !== "" ? String(raw).split(",") : [];
  const out = [];
  const seen = new Set();
  for (const item of list) {
    const s = String(item ?? "").trim();
    if (!s || seen.has(s)) continue;
    seen.add(s);
    out.push(s);
  }
  return out;
}

function normalizeLabels(map) {
  if (!map || typeof map !== "object") return {};
  const out = {};
  for (const [k, v] of Object.entries(map)) {
    const id = String(k).trim();
    const label = String(v ?? "").trim();
    if (!id || !label) continue;
    out[id] = label;
  }
  return out;
}

function resolveStatus(raw) {
  const v = String(raw || "").trim().toLowerCase();
  if (v === "active" || v === "cancelled") return v;
  return "";
}

export function normalizePassagensFilterState(raw) {
  const s = raw && typeof raw === "object" ? raw : {};
  const labels = s.labels && typeof s.labels === "object" ? s.labels : {};
  return {
    origens: toStringIdArray(s.origens),
    destinos: toStringIdArray(s.destinos),
    ids_origens: toPositiveIntArray(s.ids_origens),
    status: resolveStatus(s.status),
    labels: {
      origens: normalizeLabels(labels.origens),
      destinos: normalizeLabels(labels.destinos),
      channels: normalizeLabels(labels.channels),
    },
  };
}

export function countPassagensFilterCriteria(state) {
  const s = normalizePassagensFilterState(state);
  let n = 0;
  if (s.origens.length) n += 1;
  if (s.destinos.length) n += 1;
  if (s.ids_origens.length) n += 1;
  if (s.status) n += 1;
  return n;
}

export function passagensFilterStateToQueryParams(state) {
  const s = normalizePassagensFilterState(state);
  const params = {};
  if (s.origens.length) params.origens = s.origens;
  if (s.destinos.length) params.destinos = s.destinos;
  if (s.ids_origens.length) params.ids_origens = s.ids_origens;
  if (s.status) params.status = s.status;
  return params;
}

export function buildPassagensFilterSummaries(state, t) {
  const s = normalizePassagensFilterState(state);
  const items = [];
  const tr = (key, fallback, vars) =>
    t(`dashboardPage.passagensFilters.${key}`, { defaultValue: fallback, ...vars });

  s.origens.forEach((origem) => {
    const label = s.labels.origens[origem] || origem;
    items.push({
      key: `origem:${origem}`,
      label,
      title: tr("chipOrigemTooltip", "Origem: {{value}}", { value: label }),
      tone: "emphasis",
    });
  });

  s.destinos.forEach((destino) => {
    const label = s.labels.destinos[destino] || destino;
    items.push({
      key: `destino:${destino}`,
      label,
      title: tr("chipDestinoTooltip", "Destino: {{value}}", { value: label }),
      tone: "emphasis",
    });
  });

  s.ids_origens.forEach((id) => {
    const label = s.labels.channels[String(id)] || `#${id}`;
    items.push({
      key: `canal:${id}`,
      label,
      title: tr("chipChannelTooltip", "Canal: {{value}}", { value: label }),
    });
  });

  if (s.status) {
    const label =
      s.status === "active"
        ? tr("statusActive", "Ativas")
        : tr("statusCancelled", "Canceladas");
    items.push({
      key: "status",
      label,
      title: label,
    });
  }

  return items;
}
